
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import {
  BarChart3,
  Users,
  Target,
  Gift,
  Share2,
  Settings,
  Zap,
  BookOpen,
  Receipt,
  Calendar
} from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";

const navigationItems = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: BarChart3,
    description: "Visão geral dos seus dados"
  },
  {
    title: "Cashback",
    href: "/cashback",
    icon: Gift,
    description: "Configurações de cashback"
  },
  {
    title: "Cashback Agendado",
    href: "/scheduled-coupons",
    icon: Calendar,
    description: "Visualize cashback agendado"
  },
  {
    title: "Campanhas",
    href: "/campaigns",
    icon: Target,
    description: "Gerencie suas campanhas"
  },
  {
    title: "Clientes",
    href: "/customers",
    icon: Users,
    description: "Base de clientes"
  },
  {
    title: "Indicações",
    href: "/referrals",
    icon: Share2,
    description: "Sistema de referências",
    badge: "Em Breve"
  },
  {
    title: "Biblioteca",
    href: "/content-library",
    icon: BookOpen,
    description: "Conteúdos e materiais"
  },
  {
    title: "Integrações",
    href: "/integrations",
    icon: Zap,
    description: "Conecte suas ferramentas"
  },
  {
    title: "Configurações",
    href: "/settings",
    icon: Settings,
    description: "Configurações da conta"
  }
];

export const SidebarNavigation = () => {
  const location = useLocation();
  const { state } = useSidebar();

  return (
    <nav className="flex-1 px-2 pb-4 space-y-1">
      {navigationItems.map((item) => {
        const isActive = location.pathname === item.href;
        const Icon = item.icon;

        const linkContent = (
          <>
            <Icon 
              className={cn(
                "flex-shrink-0 h-5 w-5",
                state === "collapsed" ? "mr-0" : "mr-3"
              )} 
            />
            {state === "expanded" && (
              <span className="truncate">
                {item.title}
              </span>
            )}
            {state === "expanded" && item.badge && (
              <Badge variant="secondary" className="ml-auto text-xs">
                {item.badge}
              </Badge>
            )}
          </>
        );


        return (
          <Link
            key={item.href}
            to={item.href}
            className={cn(
              "group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200",
              isActive
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
            )}
            title={state === "collapsed" ? item.title : undefined}
          >
            {linkContent}
          </Link>
        );
      })}
    </nav>
  );
};
